import { ReactNode } from "react"
import {
  ListItem,
  ListItemLabel,
  ListItemProps,
  Mats,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { separateThousandsWithComaRegExp } from "#/shared/utils"

type OverviewRewardsMatsItemProps = ListItemProps & {
  title: string
  mats: number
  children: ReactNode
}

export default function OverviewRewardsMatsItem({
  title,
  mats,
  children,
  ...props
}: OverviewRewardsMatsItemProps) {
  const [, theme] = useStyletron()

  return (
    <ListItem
      artwork={() => <Mats color={theme.colors.red500} />}
      overrides={{
        ArtworkContainer: {
          style: () => ({ width: "80px", height: "80px" }),
        },
        Content: { style: () => ({ borderBottom: "none" }) },
      }}
      {...props}
    >
      <ListItemLabel
        description={
          <>
            <ParagraphSmall
              marginTop={theme.sizing.scale100}
              color={theme.colors.contentSecondary}
              display="block"
              as="span"
            >
              {separateThousandsWithComaRegExp(mats.toString())} mats
            </ParagraphSmall>
            {children}
          </>
        }
      >
        {title}
      </ListItemLabel>
    </ListItem>
  )
}
